import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../App";
import { Button } from "../../components/ui/button";
import BRAND from "../../brand";
import { Play } from "lucide-react";

export function FooterCTA() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCTA = () => {
    navigate(user ? "/dashboard" : "/login");
  };

  return (
    <>
      {/* FINAL CTA */}
      <section className="py-16 sm:py-24 px-5 sm:px-6 lg:px-8" data-testid="cta-section">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6 leading-tight">Ready to Transform<br />Your Sales Team?</h2>
          <p className="text-sm sm:text-lg text-slate-500 mb-8 sm:mb-10 max-w-xl mx-auto px-2">
            Stop losing deals to unprepared conversations. Start building field-ready advisors today.
          </p>
          <Button onClick={handleCTA} className="w-full sm:w-auto bg-[#0B1F3B] hover:bg-[#0B1F3B]/90 h-12 sm:h-14 px-10 text-base rounded-full btn-premium" data-testid="final-cta-btn">
            <Play className="w-5 h-5 mr-2" /> Start Practice
          </Button>
          <p className="text-[10px] sm:text-xs text-slate-400 mt-3 sm:mt-4">No credit card required</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-slate-200/60 bg-white" data-testid="landing-footer">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-8 sm:py-10">
          <div className="flex flex-col items-center gap-5 sm:gap-6 md:flex-row md:justify-between">
            <div className="flex items-center gap-2 sm:gap-3">
              <img src={BRAND.logoUrl} alt="Revyniqx" className="h-6 sm:h-8 w-auto" onError={(e) => { e.target.style.display = 'none'; }} />
              <div className="min-w-0">
                <p className="text-xs sm:text-sm font-bold text-[#0B1F3B] truncate">{BRAND.productName}</p>
                <p className="text-[10px] sm:text-xs text-slate-400 truncate">{BRAND.positioning.description}</p>
              </div>
            </div>
            <div className="flex items-center gap-6 sm:gap-8">
              <Link to="/login" className="text-xs sm:text-sm text-slate-500 hover:text-[#0B1F3B]">Log In</Link>
              <Link to="/register" className="text-xs sm:text-sm text-slate-500 hover:text-[#0B1F3B]">Get Started</Link>
            </div>
            <div className="text-center md:text-right">
              <p className="text-[10px] sm:text-xs text-slate-400">{BRAND.poweredBy}</p>
              <p className="text-[10px] sm:text-xs text-slate-300">{BRAND.companyAttribution}</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
